<template>
  <portal-layout>
    <div class="cart-page">
      <div class="page-head">
        <h2 class="page-title">购物车</h2>
      </div>

      <div v-loading="loading" class="cart-card">
        <div v-if="!loading && records.length === 0" class="empty-tip">
          购物车空空如也~
          <el-button type="text" @click="goShop">去逛逛</el-button>
        </div>

        <template v-else>
          <div v-for="item in records" :key="item.commodityCode" class="cart-item">
            <div class="item-cover" @click="goDetail(item)">
              <img :src="item.shopCommondityResVo.mainPic" :alt="item.shopCommondityResVo.title" />
            </div>
            <div class="item-info">
              <div class="item-title" @click="goDetail(item)">
                {{ item.shopCommondityResVo.title }}
              </div>
              <div class="item-subtitle">{{ item.shopCommondityResVo.subtitle }}</div>
              <div class="item-meta">
                <span v-if="item.shopCommondityResVo.courseName" class="meta-text">
                  课程：{{ item.shopCommondityResVo.courseName }}
                </span>
                <span class="meta-text">课次：{{ item.shopCommondityResVo.courseNum }} 次</span>
              </div>
              <div class="item-price">
                <span class="actual-price">¥{{ item.shopCommondityResVo.actualPrice }}</span>
                <span class="original-price">¥{{ item.shopCommondityResVo.totalPrice }}</span>
              </div>
            </div>
            <div class="item-action">
              <el-tag size="mini" :type="item.shopCommondityResVo.status === '1' ? 'success' : 'info'">
                {{ item.shopCommondityResVo.status === '1' ? '在售' : '已下架' }}
              </el-tag>
              <el-button type="primary" size="small" class="buy-item-btn"
                         :disabled="item.shopCommondityResVo.status !== '1'"
                         @click="buyItem(item)">
                立即购买
              </el-button>
              <el-button type="text" class="remove-btn" @click="removeItem(item)">
                移出购物车
              </el-button>
            </div>
          </div>

          <div class="cart-footer">
            <span class="footer-tip">购物车按行单独结算，如需多件或课程咨询请联系老师</span>
            <el-button type="primary" size="medium" @click="goContact">联系老师</el-button>
          </div>
        </template>
      </div>

      <div v-if="total > 0" class="pagination-container">
        <el-pagination background layout="total, prev, pager, next" :total="total"
                       :current-page.sync="pageNum" :page-size="pageSize"
                       @current-change="queryCart"></el-pagination>
      </div>

      <!-- 微信扫码支付 -->
      <pay-qrcode-dialog ref="payDialog" @success="onPaySuccess" />
    </div>
  </portal-layout>
</template>
<script>
import PortalLayout from '@/components/PortalLayout.vue';
import PayQrcodeDialog from '@/components/PayQrcodeDialog.vue';
import api from '@/common/api';
import storage from '@/common/storage.js';

export default {
  name: 'PortalShopCar',
  components: { PortalLayout, PayQrcodeDialog },
  data() {
    return {
      loading: false,
      records: [],
      total: 0,
      pageNum: 1,
      pageSize: 10
    }
  },
  created() {
    if (!this.checkLogin()) {
      return;
    }
    this.queryCart();
  },
  methods: {
    checkLogin() {
      if (!storage.getString('portalMember')) {
        if (this.$route.name === 'PortalLogin') return false;
        this.$router.push({ name: 'PortalLogin', query: { redirect: this.$route.fullPath } }).catch(() => {});
        return false;
      }
      return true;
    },
    queryCart() {
      this.loading = true;
      api.query_shop_car({
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then((r) => {
        if (r.data.code === "200") {
          // 后端 R.ok(page) 走 data 字段，返回 MyBatis-Plus 分页对象
          const page = r.data.data || {};
          this.records = page.records || [];
          this.total = page.total || 0;
        }
      }).catch(() => {
        // 401 已由 common/api.js 统一跳转登录页
      }).finally(() => {
        this.loading = false;
      });
    },
    // 后端 updateShopCar 是「切换」语义，已在车里再调一次即为移出
    removeItem(item) {
      api.update_shop_car({ commId: item.shopCommondityResVo.id }).then((r) => {
        if (r.data.code === "200") {
          this.$message.success('已移出购物车');
          this.queryCart();
        }
      }).catch(() => {});
    },
    goDetail(item) {
      this.$router.push('/portal/shop/detail?id=' + item.shopCommondityResVo.id).catch(() => {});
    },
    // 按行单独下单：门户端一次只买购物车中的一件商品
    buyItem(item) {
      const comm = item.shopCommondityResVo;
      if (comm.status !== '1') {
        this.$message.warning('商品已下架，无法购买');
        return;
      }
      const quantity = item.quantity || 1;
      this.$refs.payDialog.open({
        totalPrice: this.multiplyPrice(comm.actualPrice, quantity),
        items: [{
          commodityCode: comm.commodityCode,
          quantity: quantity,
          price: comm.actualPrice
        }],
        amount: this.multiplyPrice(comm.actualPrice, quantity)
      });
    },
    // 后端要求总金额与订单行金额之和严格相等，统一保留两位小数避免浮点误差
    multiplyPrice(price, quantity) {
      return (Number(price) * Number(quantity)).toFixed(2);
    },
    onPaySuccess() {
      this.$router.push('/portal/order/list').catch(() => {});
    },
    goShop() {
      this.$router.push('/portal/shop/list').catch(() => {});
    },
    goContact() {
      this.$router.push('/portal/shop/contact').catch(() => {});
    }
  }
};
</script>
<style scoped>
.page-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.page-title {
  font-size: 22px;
  color: #303133;
  margin: 0;
}
.cart-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 10px 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  min-height: 200px;
}
.cart-item {
  display: flex;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #ebeef5;
}
.cart-item:last-of-type {
  border-bottom: none;
}
.item-cover {
  flex-shrink: 0;
  width: 110px;
  height: 82px;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  background-color: #f5f7fa;
}
.item-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.item-info {
  flex: 1;
  min-width: 0;
  padding: 0 20px;
}
.item-title {
  font-size: 15px;
  color: #303133;
  font-weight: 500;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-title:hover {
  color: #409EFF;
}
.item-subtitle {
  font-size: 13px;
  color: #909399;
  margin-top: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-meta {
  margin-top: 6px;
}
.meta-text {
  font-size: 12px;
  color: #909399;
  margin-right: 15px;
}
.item-price {
  margin-top: 8px;
}
.actual-price {
  font-size: 16px;
  color: #F56C6C;
  font-weight: bold;
  margin-right: 10px;
}
.original-price {
  font-size: 12px;
  color: #c0c4cc;
  text-decoration: line-through;
}
.item-action {
  flex-shrink: 0;
  width: 120px;
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}
.buy-item-btn {
  min-width: 88px;
}
.remove-btn {
  font-size: 13px;
  color: #F56C6C;
}
.cart-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  padding: 20px 0 10px;
  border-top: 1px solid #ebeef5;
}
.footer-tip {
  font-size: 13px;
  color: #909399;
}
.empty-tip {
  text-align: center;
  color: #909399;
  padding: 60px 0;
  font-size: 14px;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>
